import "./price-range-filter";

const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", (e) => {
      this.debouncedOnSubmit(e);
    });
    facetForm.addEventListener("aria-listbox:change", (e) => {
      const productGridSection = document.getElementById(
        "product-grid-section",
      );
      this.debouncedOnSubmit(e);
    });
    facetForm.addEventListener("click", (e) => {
      const viewLink = e.target.closest("[data-facet-view]");

      if (!viewLink) return;

      e.preventDefault();

      const layout = viewLink.dataset.facetView;

      FacetFiltersForm.setLoading().then(() => {
        document
          .querySelector("#product-grid-section")
          ?.classList.toggle(
            "product-card-layout-featured",
            layout === "featured",
          );

        this.querySelectorAll("[data-facet-view]").forEach((el) =>
          el.classList.toggle("active", el === viewLink),
        );

        try {
          window.localStorage.setItem("plp-layout", layout);
        } catch (e) {
          console.warn(e);
        }

        FacetFiltersForm.setDoneLoading();
      });
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    FacetFiltersForm.setLoading();

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.awaitLoadingState.then(() => {
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.setDoneLoading();
        });
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.awaitLoadingState.then(() => {
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.setDoneLoading();
    });
  }

  static renderProductGridContainer(html) {
    const grid = document.getElementById("ProductGridContainer");

    const doc = new DOMParser().parseFromString(html, "text/html");

    grid.innerHTML = doc.getElementById("ProductGridContainer").innerHTML;

    // grid.querySelector("animate-in-view")?.remove();

    // grid.parentElement.prepend(doc.querySelector("animate-in-view"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`,
      ).innerHTML = element.innerHTML;
    });

    // FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter"),
      );
  }

  // static renderActiveFacets(html) {
  //   const activeFacetElementSelectors = [
  //     "[data-active-filters-mobile]",
  //     "[data-active-filters-desktop]",
  //   ];

  //   activeFacetElementSelectors.forEach((selector) => {
  //     const activeFacetsElement = html.querySelector(selector);
  //     if (!activeFacetsElement) return;

  //     document.querySelectorAll(selector).forEach((el) => {
  //       el.innerHTML = activeFacetsElement.innerHTML;
  //     });
  //   });
  // }

  static renderAdditionalElements(html) {
    const additionalElements = html.querySelectorAll("[data-render]");

    additionalElements.forEach((el) => {
      const selector = `[data-render="${el.dataset.render}"]`;
      const target = document.querySelector(selector);

      if (!target) return;
      target.innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.replaceState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid-section").dataset.id,
      },
    ];
  }

  static setLoading() {
    const grid = document.querySelector("[data-product-grid]");

    const promise = (FacetFiltersForm.awaitLoadingState = (
      FacetFiltersForm.awaitLoadingState || Promise.resolve()
    ).then(
      () =>
        new Promise((resolve) => {
          const onEnd = (e) => {
            if (e.target != grid) return;
            grid.removeEventListener("transitionend", onEnd);
            resolve();
          };

          grid.addEventListener("transitionend", onEnd);
          // setTimeout(() => {
          //   resolve();
          // }, 250);
        }),
    ));

    grid.classList.add("loading");

    return promise;
  }

  static setDoneLoading() {
    document.querySelector("[data-product-grid]").classList.remove("loading");
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    var paramStr = new URLSearchParams(formData).toString();
    if (paramStr.includes("filter.v.option.size")) {
      if (!paramStr.includes("filter.v.availability")) {
        paramStr += "&filter.v.availability=1";
      }
    } else {
      if (paramStr.includes("&filter.v.availability")) {
        paramStr = paramStr.replace("&filter.v.availability=1", "");
      }
      if (paramStr.includes("?filter.v.availability")) {
        paramStr = paramStr.replace("filter.v.availability=1&", "");
      }
    }
    return paramStr;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form",
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form"),
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];

      sortFilterForms.forEach((form) => {
        if (
          form.id === "FacetSortForm" ||
          form.id === "FacetFiltersForm" ||
          form.id === "FacetSortDrawerForm"
        ) {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
